<template>
  <div id="app" v-cloak>
<!--    <spin-wheel></spin-wheel>-->
    <the-navbar />
    <component :is="activeView" />
    <vue-confirm-dialog></vue-confirm-dialog>
    <notifications position="bottom right" group="foo" />
  </div>
</template>

<script>
  import SpinWheel from "@/components/SpinTheWheel";
  import TheNavbar from "@/components/TheNavbar";
  import TicTacToe from "@/components/TicTacToe";
  import one_to_50 from "@/components/1to50";
  import Match from "@/views/Match";
  // eslint-disable-next-line no-unused-vars
  import axios from "axios";
  export default {
    components: {
      SpinWheel,
      TheNavbar,
      TicTacToe,
      Match,
      one_to_50
    },
    mounted() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      //console.log(params.get("trivia_id"));
      this.$store.commit('matchSlug',params.get("trivia_id"));
      this.$store.commit('setUserId',params.get("user_id"));
      this.$store.commit('isp',params.get("isp")==='true');
      this.$store.commit('setCurrentPlayer',{'team_id':params.get("team_id"),'team_name':params.get('team_name'),'name':params.get("nickname"),'phone':params.get("phone"),'id':params.get("pid")});
      //this.$store.commit('setCurrentTeam',{'team_id':params.get("team_id"),'team_name':params.get('team_name')});
      //this.$store.dispatch("client/startListener");

      this.$store.dispatch("viewGame", {'trivia_id':params.get("trivia_id"),'isp':params.get("isp")});
      let elem = document.documentElement;

      /* View in fullscreen */

        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) { /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
          elem.msRequestFullscreen();
        }

    },
    computed: {
      activeView() {
        //return () => import("@/components/1to50");
        // Get status of the Match
        //const isOnBreak = this.$store.state.isOnBreak;
        //if(isOnBreak)
        //return () => import("@/components/MysteryBoxes");

        return () => import("@/views/Match");
      }
    },
    destroyed() {
      this.$store.dispatch("client/stopListener");
      this.$store.dispatch("leaveGame");
    }
  };
</script>

<style lang="sass">
  @import './styles/global.sass'
</style>
<style>
  .vc-container {
    background-color: #93278f;
    border-radius: 1rem;
    width: 286px;
    height: auto;
    display: grid;
    grid-template-rows: 1fr max-content;
    box-shadow: var(--container-box-shadow);
  }
  .vc-text, .vc-title {
    padding: 0 1rem;
    width: 100%;
    text-align: center;
    line-height: normal;
  }

   .vc-title {
     color: #ffbb04;
     font-weight: var(--font-weight-black);
     font-size: var(--font-size-m);
     margin-bottom: 5px;
   }
  .vc-text {
    color: #ffffff;
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-s);
  }
  .vc-btn {
    border-radius: 0 0 1rem 0;
    color: #93278f;
    background-color: var(--button-background-color);
    border: 0;
    font-size: 1rem;
    border-top: 1px solid var(--button-border-color);
    cursor: pointer;
    font-weight: var(--font-weight-bold);
    outline: none;
    min-height: 50px;
  }
</style>
<style lang="sass" scoped>
  .donut
    transform: rotate(-90deg)

  main
    display: grid
    grid-template: 'main'
    flex: 1
    position: relative
    overflow: hidden
    background: $color-white

  main > *
    grid-area: main // Transition: make sections overlap on same cell
    flex: 1 1 auto
    position: relative
    height: 100% // To be fixed
    background: $color-white


  main > :first-child
    z-index: 10 // Prevent flickering on first frame when transition classes not added yet

  /* Transitions */

  .next-leave-to
    animation: leaveToLeft 600ms both cubic-bezier(0.165, 0.84, 0.44, 1)
    z-index: 0

  .next-enter-to
    animation: enterFromRight 600ms both cubic-bezier(0.165, 0.84, 0.44, 1)
    z-index: 1


  .prev-leave-to
    animation: leaveToRight 600ms both cubic-bezier(0.165, 0.84, 0.44, 1)
    z-index: 1

  .prev-enter-to
    animation: enterFromLeft 600ms both cubic-bezier(0.165, 0.84, 0.44, 1)
    z-index: 0

  @keyframes leaveToLeft
    from
      transform: translateX(0)

    to
      transform: translateX(-100%)

  @keyframes enterFromLeft
    from
      transform: translateX(-100%)

    to
      transform: translateX(0)

  @keyframes leaveToRight
    from
      transform: translateX(0)

    to
      transform: translateX(100%)

  @keyframes enterFromRight
    from
      transform: translateX(100%)

    to
      transform: translateX(0)
</style>
